import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { variants, Row } from './StickyCTATotalsContentRow';
import { CatCreditsSection } from './StickyCTATotalsContentCreditSection';
import { amountStringToNumber } from './utils';

const getAdjustmentData = adjustment => {
  const adjustmentNum = amountStringToNumber(adjustment ?? '0');
  const isPositiveAmount = !!adjustmentNum && adjustmentNum >= 0;
  return {
    labelTranslationKey: isPositiveAmount
      ? 'MA_OH_ORD_ADJ'
      : 'DISCOUNT_ORDER_TOTAL',
    variant: isPositiveAmount ? variants.DEFAULT : variants.DISCOUNT,
    value: adjustmentNum ? adjustment : ''
  };
};

const StickyCTATotalsContent = ({
  subtotal,
  shippingCost,
  tax,
  taxLabel = [],
  catCreditTotal,
  orderRemainingPaymentAmount,
  orderAdjustment,
  catCreditSectionEnabled = false,
  forceShippingDisplay = true
}) => {
  const [t] = useTranslation();
  const adjustmentData = getAdjustmentData(orderAdjustment);
  return (
    <div className="w-100 d-flex flex-column justify-content-start align-items-center">
      <Row
        label={t('MINI_SHOPCART_SUBTOTAL')}
        amount={subtotal}
        className="mb-1"
      />
      <Row
        label={t(adjustmentData.labelTranslationKey)}
        amount={adjustmentData.value}
        variant={adjustmentData.variant}
        className="mb-1"
      />
      <Row
        label={t('MA_OH_ORD_SHIPPING')}
        forceDisplay={forceShippingDisplay}
        amount={shippingCost}
        className="mb-1"
      />
      <Row
        label={t('INVOICE_TOTAL_TAX_TOTAL_HEADER_TITLE')}
        amount={tax}
        className="text-capitalize"
      />
      {taxLabel?.map(({ label, value }) => (
        <Row
          key={label}
          amount={value}
          label={label}
          variant={variants.TAX_ITEM}
        />
      ))}
      {catCreditSectionEnabled && (
        <CatCreditsSection
          catCreditTotal={catCreditTotal}
          orderRemainingPaymentAmount={orderRemainingPaymentAmount}
        />
      )}
    </div>
  );
};

StickyCTATotalsContent.propTypes = {
  subtotal: PropTypes.string,
  shippingCost: PropTypes.string,
  tax: PropTypes.string,
  orderAdjustment: PropTypes.string,
  taxLabel: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  catCreditSectionEnabled: PropTypes.bool,
  forceShippingDisplay: PropTypes.bool,
  ...CatCreditsSection.propTypes
};

export default StickyCTATotalsContent;
